class MCarousel extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        slider_element: this
      }
      this.init();
    }
  
    connectedCallback() {
      if (Shopify.designMode) {
        this.onShopifySectionLoad = this.onSectionLoad.bind(this);
        this.onShopifySectionSelect = this.onSectionSelect.bind(this);
        this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
        document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
        document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
        document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
      }
    }

    disconnectedCallback() {
        if (Shopify.designMode) {
          document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
          document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
          document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
        }
      }

    onSectionLoad(event) {
      filterShopifyEvent(event, this, () => this.initSlider.bind(this));
    }
    onSectionSelect(event) {
      filterShopifyEvent(event, this, this.initSlider.bind(this));
    }
    onSectionDeselect(event) {
      filterShopifyEvent(event, this, this.initSlider.bind(this));
    }
  
  
    init() {
      if (Shopify && Shopify.designMode) {
        this.initSlider();
      }
      setTimeout(() => {
        this.initSlider();
      });
      window.addEventListener('resize', this.handleWindowResize.bind(this));
    }
  

    handleWindowResize() {
      const tablet = window.matchMedia('(min-width: 750px)');
      if (!tablet.matches) {
        if (!this.swiper) {
          this.initSlider();
        }
      } else {
        if (this.swiper) {
          this.destroySlider();
        }
      }
    }
  
    initSlider() {
        let _tablet = window.matchMedia('(min-width: 750px)');
        if(!_tablet.matches) {
              var swiper = new Swiper(this.elements.slider_element, {
                  slidesPerView: 2,
                  spaceBetween: 8,
                  pagination: {
                      el: '.swiper-pagination',
                      clickable: true,
                  }
              });
          }
    }
    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
  }
  
  }
  customElements.define('multicolumn-carousel', MCarousel);
  